import React, {useCallback, useMemo} from 'react';
import styled from 'styled-components';

const StyledSelect = styled.select`
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    margin-top: 0.5rem;
    border-radius: 0.25rem;
    border: 1px solid #ccc;
`;

/**
 * @param {string} input - Raw string value from the select element
 * @returns {boolean | null}
 */
const normalizeVetPrescriptionValue = (input) => {
    if (input === 'true') return true;
    if (input === 'false') return false;
    return null;
};

/**
 * @param {boolean | null | undefined} value - The vetPrescription filter state
 * @returns {string}
 */
const getVetPrescriptionSelectValue = (value) => {
    if (value === true) return 'true';
    if (value === false) return 'false';
    return '';
};

/**
 * @param {{
 *   options: any,
 *   value: { characteristics: { prescription: boolean | null } | null},
 *   onChange: (val: boolean | null) => void
 * }} props
 * @returns {JSX.Element}
 */
export const CharacteristicsFilterUI = ({ options, value, onChange }) => {
    const prescription = useMemo(() => value?.characteristics?.prescription, [value]);

    const handleChange = useCallback(
        (e) => {
            const normalized = normalizeVetPrescriptionValue(e.target.value);
            onChange({ prescription: normalized });
        },
        [onChange]
    );

    return (
        <StyledSelect
            onChange={handleChange}
            value={getVetPrescriptionSelectValue(prescription)}
            className="form-select taxonomy-categories"
        >
            <option value="">Prescripción veterinaria</option>
            <option value="true">Sólo con prescripción veterinaria</option>
            <option value="false">Sin prescripción veterinaria</option>
        </StyledSelect>
    );
};
